import Cursor from 'ui/Cursor';
import Loader from 'ui/Loader';
import Anchor from 'ui/Anchor';
import FixedLogo from 'ui/FixedLogo';
import Nav from 'ui/Nav';
import ScrollAnimation from 'ui/ScrollAnimation';
import Reserve from 'ui/Reserve';
import Hero from 'pages/home/Hero';
import Menu from 'pages/home/Menu';
import ReservationForm from 'ui/ReservationForm';
import Tab from 'ui/Tab';
import Slider from 'ui/Slider';

window.addEventListener('DOMContentLoaded', () => {

  if(!(location.href.includes('/contact') || location.href.includes('/thanks') || location.href.includes('/privacy'))){
    Array.from(document.querySelectorAll('a[href^="#"]'), (el) => {
      new Anchor(el);
    });
  }

	if(location.pathname === "/program" || location.pathname === "/program/") {
		$(".footer-bg-white").css("background-color","rgb(246, 243, 240)")
	}

  new Loader();
  new Menu();
  new Cursor();
  new FixedLogo();
  new Nav();
  new ScrollAnimation();
  new Reserve();
  new Hero();
  new ReservationForm();
});

//アコーディオンをクリックした時の動作
$('.title').on('click', function() {//タイトル要素をクリックしたら
	$('.box').slideUp(500);//クラス名.boxがついたすべてのアコーディオンを閉じる
    
	var findElm = $(this).next(".box");//タイトル直後のアコーディオンを行うエリアを取得
    
	if($(this).hasClass('close')){//タイトル要素にクラス名closeがあれば
		$(this).removeClass('close');//クラス名を除去    
	}else{//それ以外は
		$('.close').removeClass('close'); //クラス名closeを全て除去した後
		$(this).addClass('close');//クリックしたタイトルにクラス名closeを付与し
		$(findElm).slideDown(500);//アコーディオンを開く
	}
});

//ページが読み込まれた際にopenクラスをつけ、openがついていたら開く動作※不必要なら下記全て削除
$(window).on('load', function(){
	$('.accordion-area li:first-of-type section').addClass("open"); //accordion-areaのはじめのliにあるsectionにopenクラスを追加
	$(".open").each(function(index, element){	//openクラスを取得
		var Title =$(element).children('.title');	//openクラスの子要素のtitleクラスを取得
		$(Title).addClass('close');				///タイトルにクラス名closeを付与し
		var Box =$(element).children('.box');	//openクラスの子要素boxクラスを取得
		$(Box).slideDown(500);					//アコーディオンを開く
	});
});

//モーダル
if($(".info").length !== 0) {
	// $(".info").modaal({
	// 	overlay_close:true,
	// 	before_open:function(){
	// 		$('html').css('overflow-y','hidden');/*縦スクロールバーを出さない*/
	// 	},
	// 	after_close:function(){
	// 		$('html').css('overflow-y','scroll');/*縦スクロールバーを出す*/
	// 	}
	// });
}

$("#menu-btn").click(function() {
	$(".menu-img").toggleClass("active")
	$("#header-nav").toggleClass("hidden")
	$(".menu-dot").toggleClass("hidden")
	$(".menu-close").toggleClass("hidden")
	$(".menu-text-close").toggleClass("hidden")
	$(".menu-text").toggleClass("hidden")
});

$("#menu-btn-sp").click(function() {
	$(".menu-img").toggleClass("active")
	$("#header-nav").toggleClass("hidden")
	$(".menu-dot").toggleClass("hidden")
	$(".menu-close").toggleClass("hidden")
	$(".sp-header").toggleClass("active")
	$("#menu-btn-sp").toggleClass("active")
	$(".menu-text-close").toggleClass("hidden")
	$(".menu-text").toggleClass("hidden")
});
